/* Collection page (dh-collection, 23 Oct 2026): the "Doar piese în stoc" switch, the showroom card after the
   n-th product and the "Ai văzut X din Y" line. Boost re-renders its grid on every filter, sort and page, so
   everything here is idempotent and re-run (debounced) on DOM changes. Card text (availability) is done by the
   collection-cards block in assets/boost-sd-custom.js. */
(function () {
  var PARAM = "pf_t_disponibilitate";

  function stockValue() {
    var b = document.querySelector("[data-dhc-stock]");
    return b ? b.getAttribute("data-dhc-stock") : null;
  }
  function stockOn() {
    var v = stockValue();
    return !!v && new URLSearchParams(location.search).getAll(PARAM).indexOf(v) !== -1;
  }
  /* Boost's own checkbox in the filter tree, when it is on the page (desktop) */
  function boostStockButton() {
    var v = (stockValue() || "").replace(/^STOC_/, "");
    var btns = document.querySelectorAll(".boost-sd__filter-option-item-button");
    for (var i = 0; i < btns.length; i++) {
      var opt = btns[i].closest(".boost-sd__filter-option");
      if (opt && /Disponibilitate/i.test(opt.textContent) && btns[i].textContent.trim().indexOf(v) === 0) return btns[i];
    }
    return null;
  }
  function wireStock() {
    var b = document.querySelector("[data-dhc-stock]");
    if (!b) return;
    b.setAttribute("aria-pressed", stockOn() ? "true" : "false");
    if (b.dataset.wired) return;
    b.dataset.wired = "1";
    b.addEventListener("click", function () {
      var native = boostStockButton();
      if (native) { native.click(); return; }
      /* mobile: the filter tree is not rendered until opened — go by the URL, Boost reads it on load */
      var q = new URLSearchParams(location.search), v = stockValue();
      var vals = q.getAll(PARAM).filter(function (x) { return x !== v; });
      q.delete(PARAM);
      if (!stockOn()) vals.push(v);
      vals.forEach(function (x) { q.append(PARAM, x); });
      q.delete("page");
      location.search = q.toString();
    });
  }

  function placeInsert() {
    var tpl = document.getElementById("dhc-insert");
    if (!tpl) return;
    var items = document.querySelectorAll(".boost-sd__product-item");
    var after = parseInt(tpl.getAttribute("data-after"), 10) || 6;
    var cur = document.querySelector(".dhc-insert");
    if (items.length <= after) { if (cur) cur.remove(); return; }
    var anchor = items[after - 1];
    if (cur && cur.previousElementSibling === anchor) return;
    if (cur) cur.remove();
    anchor.parentNode.insertBefore(tpl.content.firstElementChild.cloneNode(true), anchor.nextSibling);
  }

  function seen() {
    /* page numbers, or the "load more" button (Boost setting, switched by Eduard 23 Oct) */
    var pag = document.querySelector(".boost-sd__pagination-load-more-container, .boost-sd__pagination");
    var countEl = document.querySelector(".boost-sd__product-count");
    var old = document.querySelector(".dhc-seen");
    if (!pag || !countEl) { if (old) old.remove(); return; }
    var total = Number((countEl.textContent.match(/[\d.,]+/) || ["0"])[0].replace(/[.,]/g, ""));
    var shown = document.querySelectorAll(".boost-sd__product-item").length;
    var active = document.querySelector(".boost-sd__pagination-number--active");
    var page = active ? Number(active.textContent.trim()) || 1 : 1;
    var upto = Math.min(total, (page - 1) * shown + shown);
    if (!total || upto >= total && page === 1) { if (old) old.remove(); return; }
    var text = "Ai văzut " + upto.toLocaleString("ro-RO") + " din " + total.toLocaleString("ro-RO") +
      (total % 100 >= 1 && total % 100 <= 19 || total < 20 ? " produse" : " de produse");
    var pct = Math.max(2, Math.round(upto / total * 100)) + "%";
    if (old && old.dataset.t === text && old.nextElementSibling === pag) return;
    if (old) old.remove();
    var d = document.createElement("div");
    d.className = "dhc-seen";
    d.dataset.t = text;
    d.innerHTML = '<span></span><span class="dhc-seen__bar" aria-hidden="true"><span></span></span>';
    d.firstChild.textContent = text;
    d.querySelector(".dhc-seen__bar span").style.width = pct;
    pag.parentNode.insertBefore(d, pag);
  }

  function run() {
    wireStock();
    placeInsert();
    seen();
  }
  var t = null;
  function queue() { clearTimeout(t); t = setTimeout(run, 120); }
  function start() {
    run();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    window.addEventListener("popstate", queue);
  }
  if (document.readyState !== "loading") start(); else document.addEventListener("DOMContentLoaded", start);
})();
